export default __webpack_public_path__ + "static/media/W.49af27c3.svg";